import React from 'react';
import { TransformCTA } from '../TransformCTA';
import { contents } from '../../data/content';
export function Contents() {
  return <section className="w-full bg-white px-4 py-14 sm:py-20" data-id="element-122" data-mp="32np5fn3wnaj3">
      <div className="mx-auto w-full max-w-5xl" data-id="element-123" data-mp="2nrga2wn4xhby">
        <h2 className="text-center font-display text-[26px] font-black leading-tight tracking-tight text-navy-950 sm:text-4xl" data-id="element-124" data-mp="2nqoj5z4hg7s0">
          📦 ¿Qué contiene Ruta Hipotiroidismo™?
        </h2>

        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-125" data-mp="2exbl6irkafz2">
          {contents.map(item => <li key={item.title} className="rounded-3xl border border-navy-100 bg-navy-50/50 p-5 sm:p-6" data-id="element-126" data-mp="2jqwdpvadyhqv">
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white text-2xl shadow-sm" aria-hidden="true" data-id="element-127" data-mp="29za1bvmbacmj">
                {item.emoji}
              </span>
              <h3 className="mt-4 font-display text-[17px] font-bold leading-snug text-navy-950 sm:text-xl" data-id="element-128" data-mp="2002e8gprz3m8">
                {item.title}
              </h3>
              <p className="mt-2 text-[14px] leading-relaxed text-navy-800/80 sm:text-base" data-id="element-129" data-mp="1vts2q76gdxjw">
                {item.text}
              </p>
            </li>)}
        </ul>

        <TransformCTA headline="Ten el sistema completo abierto en tu tablet durante la próxima consulta." data-id="element-130" data-mp="2aoy9iwddi0ea" />
      </div>
    </section>;
}